<template>
    <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Unassigned Orders</h1>
      </v-col>
    </v-row>
    <v-card v-if="loading" class="pa-4 text-center">
        <v-progress-circular
            indeterminate
            color="primary"
            size="64"
        ></v-progress-circular>
        <div class="text-h6 mt-4">Loading orders...</div>
    </v-card>
    <template v-else-if="unassignedSales.length > 0">
    <v-card
      :class="getSaleClass(sale)"
      class="pa-4"
      variant="outlined"
      v-for="sale in unassignedSales"
      :key="sale.ID"
    >
      <v-row>
        <v-col cols="12" md="2">
          <v-select
            v-model="sale.Vendor"
            :items="vendorsStore.vendors"
            :menu-props="{maxHeight: 'unset'}"
            item-title="vendor"
            item-value="slug"
            label="Vendor"
            class="ml-4"
            density="comfortable"
            hide-details
            :loading="assigning[sale.ID]"
            @update:model-value="assignVendor(sale)"
          ></v-select>
        </v-col>
        <v-col cols="12" md="1">
            <a
          :href="`/sales/${sale.ID}`"
          color="primary"
        >
          {{ sale.ID }}
        </a>
        </v-col>
        <v-col cols="12" md="2">
            {{ sale.PONumber }}
        </v-col>
        <v-col cols="12" md="5">
            {{ sale.itemtitle }}
        </v-col>
        <v-col cols="12" md="1">
            {{  sale.itemnumber }}
        </v-col>
        <v-col cols="12" md="1">
            {{  sale.Site }}
            </v-col>
        </v-row>
    </v-card>
    </template>
    <v-card v-else class="pa-4 text-center">
        <v-icon
            icon="mdi-package-variant"
            size="64"
            color="grey"
        ></v-icon>
        <div class="text-h6 mt-4">No unassigned orders found</div>
        <div class="text-body-1 text-grey mt-2">
            There are currently no orders to process.
        </div>
    </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { vendorsService } from '@/services/vendorsService'
import { useVendorsStore } from '@/stores/vendorsStore'
import { orderService } from '@/services/orderService'
import { getSaleClass } from '@/utils/SaleClass'
const vendorsStore = useVendorsStore()

const unassignedSales = ref([])
const assigning = ref({})   
const loading = ref(false)

onMounted(async () => {
    loading.value = true
    unassignedSales.value= await vendorsService.getUnassignedSales()
    loading.value = false
})

const assignVendor = async (sale) => {
    assigning[sale.ID] = true
    try {
        await orderService.assignVendor(sale.Vendor, [sale.ID])
        unassignedSales.value = unassignedSales.value.filter(s => s.ID !== sale.ID)
    } catch (error) {
        console.error('Error assigning vendor:', error)
    }
    assigning[sale.ID] = false
}
</script>
